<div class="program-name">
  <h4>{{ office.name }}</h4>
  <span *ngIf="office.isAdministrative">Admin-Only</span>
</div>
<div class="location-info">
  <div class="contact-info">
    <div class="location-item" *ngIf="office.city && office.state && office.distance">
      <svg-icon src="/assets/icons/location.svg" class="hidden-print"></svg-icon>
      <div class="location-address hidden-screen">
        <p><strong>Address</strong></p>
        <ng-container *ngTemplateOutlet="location; context: { office }"></ng-container>
      </div>
      <div class="location-address hidden-print">
        <a [href]="googleMapsDirectionsLink" target="_blank" class="underline-link">
          <ng-container *ngTemplateOutlet="location; context: { office }"></ng-container>
        </a>
        <p class="distance" *ngIf="!office.isAdministrative">{{ office.distance }} miles away</p>
      </div>
    </div>
    <div class="location-item" *ngIf="websiteUrl">
      <svg-icon src="/assets/icons/expand.svg" class="hidden-print"></svg-icon>
      <a [href]="websiteUrl" target="_blank" class="underline-link link-website">
        <span class="hidden-print">Visit website</span>
        <strong class="hidden-screen">Website -</strong>
      </a>
    </div>
    <div class="location-item" *ngIf="office.phoneNumber">
      <svg-icon src="/assets/icons/call.svg" class="hidden-print"></svg-icon>
      <a
        [href]="
          office.phoneNumber.phoneNumberWithoutExtension | clickableTelephoneNumber : office.phoneNumber.extension
        "
        class="underline-link link-phone">
        <strong class="hidden-screen">Phone -</strong>
        {{ office.phoneNumber.phoneNumberWithoutExtension }}
        <span *ngIf="office.phoneNumber.extension">ext. {{ office.phoneNumber.extension }}</span>
      </a>
    </div>
    <div class="location-item" *ngIf="office.email">
      <svg-icon src="/assets/icons/mail.svg" class="hidden-print"></svg-icon>
      <a
        [href]="office.email | emailLink : 'Response Requested: Seeking Program Information'"
        class="underline-link link-email">
        <strong class="hidden-screen">Email -</strong>
        {{ office.email }}
      </a>
    </div>
    <div class="location-item" *ngIf="office.fax">
      <svg-icon src="/assets/icons/fax.svg" class="hidden-print"></svg-icon>
      <p>Fax: {{ office.fax }}</p>
    </div>
  </div>
  <kp-local-resource-hours class="hours" [hours]="office.formattedHours"></kp-local-resource-hours>
</div>
<p class="location-item notes" *ngIf="office.notes">
  <svg-icon src="/assets/icons/notes.svg" class="hidden-print"></svg-icon>
  {{ office.notes }}
</p>

<ng-template #location let-office="office">
  <p>{{ office?.address1 }}</p>
  <p *ngIf="office.address2">{{ office.address2 }}</p>
  <p>
    {{ office?.city ? office.city + ', ' : false }}
    {{ office?.state ? office.state + ' ' : false }} {{ office.postal }}
  </p>
  <p class="distance hidden-screen" *ngIf="office?.distance && !office?.isAdministrative">
    {{ office.distance }}&nbsp;miles
  </p>
</ng-template>
